import { categoryBoards } from '@/mocks/home';

export default function CategoryBoards() {
  return (
    <section id="boards" className="bg-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="mb-8">
          <p className="text-xs font-label font-medium text-secondary-700 tracking-wide mb-2">
            分类专区
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
            三大专区，各走各的门
          </h2>
          <p className="mt-2 text-sm font-label text-foreground-600 max-w-2xl">
            短视频看节奏，直播看时间，福利资源看合集。三个专区各自独立，进入就能直奔目标，不必在信息流里来回翻找。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {categoryBoards.map((board) => (
            <article
              key={board.key}
              className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden bg-background-100">
                <img
                  src={board.cover}
                  alt={`小蓝视频${board.title}封面`}
                  title={`小蓝视频${board.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <span className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${board.icon} text-lg`}></i>
                </span>
              </div>

              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{board.title}</h3>
                <p className="mt-1 text-xs font-label text-foreground-500">{board.subtitle}</p>

                <ul className="mt-4 space-y-2.5 flex-1">
                  {board.items.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <i className="ri-bookmark-line text-primary-500 text-sm mt-0.5"></i>
                      <span className="text-sm font-label text-foreground-700 leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#hot"
                  className="mt-5 inline-flex items-center justify-center gap-1.5 h-10 rounded-md border border-background-300 text-sm font-label font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  进入{board.title}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}